import { useEffect, useRef, useState } from 'react';

// @Utility
import readMenuIcon from "@utility/app/readMenuIcon";

// component
import { Grid } from '@mui/material';
import WrapperContainer from "views/components/WrapperContainer";
import ImageShow from "views/components/ImageShow";
import GotoPage from "views/components/GotoPage";

export default function FooterTabMenu({ dataCms }) {
    const pageRef = useRef();
    const [dataList, setDataList] = useState([]);

    const gotoPage = (item) => {
        if(item.redirect === "playGame") {
            pageRef.current.gotoPlayGame("slot");
        }
        else {
            pageRef.current.gotoPage(item.redirect, item.login ? "login" : "notCheckLogin");
        }
    };

    useEffect(() => {
        let menuList = [
            {
                "image": readMenuIcon(dataCms?.icon_wallet, "/images/icon/wallet.webp"),
                "name": "กระเป๋า",
                "status": 1,
                "redirect": "/bag",
                "login": true,
                "center": false,
                "column": 2
            },
            {
                "image": readMenuIcon(dataCms?.icon_deposit, "/images/icon/deposit.webp"),
                "name": "ฝากเงิน",
                "status": 1,
                "redirect": "/deposit",
                "login": true,
                "center": false,
                "column": 3
            },
            {
                "image": readMenuIcon(dataCms?.icon_play, "/images/icon/playGame.webp"),
                "name": "เล่นเกม",
                "status": 1,
                "redirect": "playGame",
                "login": false,
                "center": true,
                "column": 2
            },
            {
                "image": readMenuIcon(dataCms?.icon_withdraw, "/images/icon/withdraw.webp"),
                "name": "ถอนเงิน",
                "status": 1,
                "redirect": "/withdraw",
                "login": true,
                "center": false,
                "column": 3
            },
            {
                "image": readMenuIcon(dataCms?.icon_contact, "/images/icon/contact.webp"),
                "name": "ติดต่อเรา",
                "status": 1,
                "redirect": "/contact",
                "login": false,
                "center": false,
                "column": 2
            }
        ];

        setDataList(menuList);
    }, [dataCms]);

    return (
        <>
            <GotoPage ref={pageRef}></GotoPage>

            <div className="positionFixed bottomLeft  zIndexLow footerMenu">
                <WrapperContainer className="contentWidth" maxWidth="md">
                    <Grid container alignItems="center" justifyContent="space-between" className="footerMenuHeight center" spacing={1}>
                        {
                            dataList.map((item, index) => (
                                item.center ?
                                    <Grid key={index} item xs={item.column}>
                                        <div className="positionRelative">
                                            <div className="positionAbsolute footerMenuTop leftCenter traslateCenter" onClick={() => gotoPage(item)}>
                                                <div className="cursorPointer positionRelative footerMenuListCenterAnm">
                                                    <div className="footerMenuListCenter positionRelative">
                                                        <div className="positionAbsolute topCenter leftCenter traslateCenter">
                                                            <ImageShow className="imgFooterMenuCenter" src={item.image} alt="เมนู สล็อตออนไลน์"></ImageShow>
                                                        </div>
                                                    </div>
                                                    <div className="footerMenuList footerMenuTextCenter">
                                                        {
                                                            item.name
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                    :
                                    <Grid key={index} item xs={item.column}>
                                        <div className="footerMenuList positionRelative cursorPointer"  onClick={() => gotoPage(item)}>
                                            <ImageShow className="imgFooterMenu" src={item.image} alt="เมนู สล็อตออนไลน์"></ImageShow>
                                            <div className="footerMenuText">
                                                {
                                                    item.name
                                                }
                                            </div>
                                        </div>
                                    </Grid>
                            ))
                        }
                    </Grid>
                </WrapperContainer>
            </div>
        </>
    );
}